<template>
  <b-modal
    centered
    id="change-code-receipt"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
  >
    <template #modal-header="">
      <h5>Nhập thông tin mã giao dịch mới</h5>
      <b-button size="sm" variant="light" @click="closeModalChangeCode()"> x </b-button>
    </template>
    <div>
      <div class="form-group">
        <label>Mã GD cũ</label>
        <input type="text" v-model="codeReceipt" disabled />
      </div>
      <div class="form-group">
        <label>Mã GD mới</label>
        <input type="text" v-model="transactionCode" />
      </div>
      <div class="form-group">
        <label>Lý do</label>
        <input type="text" v-model="note" />
      </div>
    </div>
    <template #modal-footer="">
      <b-button size="sm" variant="light" @click="closeModalChangeCode()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="updateChangeCode"> Xác nhận </b-button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    props: {
      codeReceipt: {
        type: String,
      },
      closeModalChangeCode: {
        type: Function,
      },
    },
    data() {
      return {
        note: '',
        transactionCode: '',
      }
    },

    methods: {
      async updateChangeCode() {
        const data = {
          note: this.note,
          transactionCode: this.transactionCode,
        }
        this.$emit('updateChangeCode', data)
      },
      onHidden() {
        this.$emit('onHidden')
      },
    },
  }
</script>

<style scoped></style>
